import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { TopBar } from '../../components/TopBar';

import imageEnd from '../../images/png/end/photo.png';

import './index.scss';

type Props = {
    baseUrl?: string;
};

export const End: FunctionComponent<Props> = ({ baseUrl = '' }) => {
    const { t } = useTranslation();
    const { language } = useParams();
    return (
        <>
            <TopBar baseUrl={baseUrl} />
            <section className={`${language} container end with-top-bar`}>
                <div className="yellow">
                    <h1>{t('end.thanks')}</h1>
                    <p>{t('end.more')}</p>
                    <a
                        className="button go"
                        href={t('end.moreLink')}
                        rel="noreferrer"
                        target="_blank"
                    >
                        {t('end.moreLinkText')}
                    </a>
                    <p>{t('end.decoder')}</p>
                    <a
                        className="button go"
                        href={t('end.decoderLink')}
                        rel="noreferrer"
                        target="_blank"
                    >
                        {t('end.decoderLinkText')}
                    </a>
                </div>
                <div className="image-end">
                    <img src={imageEnd} alt="NOH Cemetery" />
                </div>
                <div className="darkgreen">
                    <div>
                        <h2>{t('end.colophon')}</h2>
                    </div>
                    <div>
                        <h5>{t('end.direction')}</h5>
                        <span>Anne Vandenbulcke</span>
                        <span>Bérengère de Laveleye</span>
                    </div>
                    <div>
                        <h5>{t('end.conception')}</h5>
                        <span>Bruno Berghmans</span>
                        <span>Jean-Luc Petit</span>
                    </div>
                    <div>
                        <h5>{t('end.graph')}</h5>
                        <span>Clémence Cassells</span>
                    </div>
                    <div>
                        <h5>{t('end.dev')}</h5>
                        <span>Christophe Gérard</span>
                        <span>Mathieu Van der Haegen</span>
                    </div>

                    <div>
                        <h5>{t('end.photo')}</h5>
                        <span>Bruno Berghmans</span>
                        <span>Studio Fifty-Fifty</span>
                    </div>
                    <div>
                        <h5>{t('end.legal')}</h5>
                        <span>ISBN D2025/3285/18</span>
                    </div>

                    <div
                        className="disclaimer"
                        dangerouslySetInnerHTML={{
                            __html: t('end.disclaimer'),
                        }}
                    />
                </div>
            </section>
        </>
    );
};
